import { StrictMode, createRoot } from "@wordpress/element";
import SliderONGs from "./SliderONGs";

// Mount the component to the 'root' div
const roots = document.querySelectorAll('.slider-ongs-swiper');

roots.forEach((root) => {
  const perSlide = parseInt(root.getAttribute('data-per-slide')) ?? 5;

  createRoot(root).render(
    <StrictMode>
      <SliderONGs perSlide={perSlide} />
    </StrictMode>
  );
});